import { useEffect, useState } from 'react';
import useVideoContext from '../useVideoContext/useVideoContext';

type RoomStateType = 'disconnected' | 'connected' | 'reconnecting';

function mapConnectionState(s: string): RoomStateType {
  if (s === 'CONNECTED') return 'connected';
  if (s === 'CONNECTING' || s === 'RECONNECTING') return 'reconnecting';
  return 'disconnected';
}

export default function useRoomState(): RoomStateType {
  const { room } = useVideoContext();
  const [state, setState] = useState<RoomStateType>('disconnected');

  useEffect(() => {
    if (!room) {
      setState('disconnected');
      return;
    }
    setState(mapConnectionState(room.connectionState));
    const client = room.client;
    const handler = () => setState(mapConnectionState(client.connectionState));
    client.on('connection-state-change', handler);
    return () => client.off('connection-state-change', handler);
  }, [room]);

  return state;
}
